import { notification } from 'antd';
import uploadCareCanvasImage from '../../../../../api/uploadCareCanvasImage';
import { captureError, captureErrorString } from '../../../../../pages/captureError';
import { track } from '../../../../../tracking';

export const selectElementAndClick = (selector: string) => {
    const element = document.querySelector(selector) as HTMLDivElement;
    element && element.click();
};

export const dataUrlToFormData = (dataUrl: string, fileName: string) => {
    const [metadata, base64Data] = dataUrl.split(',');
    const mimeType = metadata.match(/:(.*?);/)?.[1];
    const binaryData = atob(base64Data);
    const arrayBuffer = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
        arrayBuffer[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: mimeType });
    const formData = new FormData();
    formData.append('image', blob, fileName);
    return formData;
};

export const imageToBase64 = async (url: string) => {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.statusText}`);
        }
        const buffer = await response.arrayBuffer();
        const base64Image = Buffer.from(buffer).toString('base64');
        return `data:image/jpeg;base64,${base64Image}`;
    } catch (error) {
        console.error('Error converting image to Base64:', error);
    }
};

export const uploadImage = async (base64Image: string, name: string) => {
    const formData = dataUrlToFormData(base64Image, name);
    try {
        const { success, url, error } = await uploadCareCanvasImage(formData);
        if (success) {
            return url;
        } else {
            notification.error({
                message: error || 'Failed to upload Image',
                duration: 5,
            });
            captureErrorString(error || 'Failed to upload Image');
            return '';
        }
    } catch (error) {
        notification.error({
            message: 'Failed to upload Image',
            duration: 5,
        });
        captureError(error as Error);
        track('ERROR', { on: 'uploadCareCanvasImage', what: (error as Error).message });
    }
};
